const ITEMS = [
  "Impermeabilizzazione guaina bituminosa",
  "Coperture in tegole portoghesi e marsigliesi",
  "Pannelli finto coppo coibentati 80mm",
  "Garanzia 20 anni sui lavori",
  "Detrazioni fiscali 50% – 65%",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="py-6 bg-[#13151A] border-y border-white/5 overflow-hidden"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#D97736]/80"
              >
                <span className="px-6">{item}</span>
                <span className="text-[#6B7280]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
